module.exports = __webpack_public_path__ + "static/TakeshiAndHiroshi0-fe26abd4e868fbfb0da674e2c586321c.png";